import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhoneinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22 16l1 1v5c-.003.667-.336 1-1 1C10 23 1 14 1 2c0-.667.333-1 1-1h5l1 1 1 5-2 2 8 8 2-2 5 1z",
		stroke: "currentColor",
		strokeWidth: 2,
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgPhoneinline;
